<div class="row">
  <app-cms-entity-management-inner-section-nav class="col-2"
                                          [options]="Object.values(BASIC_DETAILS_STEPS)"
                                          [activeOption]="activeBasicDetailsStep"
                                          [fragmentChangeScrolling]="fragmentChangeScrolling"
                                          (navigateTo)="navigateTo($event)"></app-cms-entity-management-inner-section-nav>
  <form [formGroup]="innerForm" class="col-10">
    <app-event-management-basic-info [id]="BASIC_DETAILS_STEPS.BASIC_INFO.id"
                                     [innerForm]="innerForm"></app-event-management-basic-info>

    <app-event-management-sports-and-disciplines [id]="BASIC_DETAILS_STEPS.SPORTS_AND_DISCIPLINES.id"
                                                 [disciplinesForm]="disciplinesForm"
                                                 [innerForm]="innerForm"></app-event-management-sports-and-disciplines>

    <app-event-management-location [id]="BASIC_DETAILS_STEPS.LOCATION.id"
                                   [innerForm]="innerForm"></app-event-management-location>
  </form>
</div>
